import { Chakra, Logos } from "@airhelp/react-ui-components";
import Link from "next/link";
import { trackClickEvent, buildTrackingBasedId } from "utils/trackingUtils";
import type { ImageCTAProps } from "../ImageCTA.d";
import { ImageCTAStylesMobile } from "./ImageCTAMobile.styles";

const { Box, Heading, Button, Flex } = Chakra;

const ImageCTAMobile = ({
  text,
  buttonText,
  buttonHref = "/404",
  imageUrl,
  gtmSection,
  gtmElement,
  variant,
}: ImageCTAProps) => (
  <Flex w="full" overflow="auto" direction="column" sx={ImageCTAStylesMobile[variant].container}>
    <Box bgImage={imageUrl} bgRepeat="no-repeat" bgSize="cover" sx={ImageCTAStylesMobile[variant].image} />
    <Box zIndex="1" sx={ImageCTAStylesMobile[variant].textContainer}>
      {variant === "ahPlus" && <Logos.AirhelpPlus h={9} w="auto" mb={4} />}
      <Heading color="inherit" {...ImageCTAStylesMobile[variant].heading}>
        {text}
      </Heading>
      <Link href={buttonHref}>
        <Button
          id={buildTrackingBasedId(gtmSection, gtmElement)}
          as={Button}
          onClick={() => trackClickEvent(gtmSection, gtmElement)}
          {...ImageCTAStylesMobile[variant].button}
        >
          {buttonText}
        </Button>
      </Link>
    </Box>
  </Flex>
);

export default ImageCTAMobile;
